import Container from './container'

export default Container


// WEBPACK FOOTER //
// ./src/providers-registrations/onboarding/index.js